module.exports = __webpack_public_path__ + "static/media/b_smart.3d5d111a.svg";